// extracted by mini-css-extract-plugin
export var phone = "_57-0";
export var phoneDragging = "_57-1";